import React, {useState} from 'react';
import {
	Card,
	CardHeader,
	CardContent,
	Table,
	TableBody,
	TableRow,
	TableCell,
	Chip,
	Tooltip,
	FormControl,
	RadioGroup,
	FormControlLabel,
	Radio,
	Button,
	Typography,
	TextField, Button as MButton, InputAdornment, IconButton
} from '@material-ui/core';
import Select from 'react-select';
import HistoryIcon from '@material-ui/icons/History';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DeleteIcon from "@material-ui/icons/Delete";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import ApplyCouponDialog from './ApplyCouponDialog';
import API from '../../../../network/dashboardAPI';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
	table: {
		width: '100%',
		minWidth: 500,
		'& .MuiTableCell-root': {
			borderBottom: 'none',
			padding: theme.spacing(1.5),
		},
		'& .MuiTableRow-root': {
			'&:hover': {
				backgroundColor: theme.palette.action.hover,
			},
		},
	},
	labelCell: {
		fontWeight: 'bold',
		width: '190px',
		verticalAlign: 'top',
		color: theme.palette.text.primary,
	},
	valueCell: {
		verticalAlign: 'top',
	},
	chip: {
		minWidth: '12rem',
		color: theme.palette.common.white,
		fontWeight: 'bold',
		textTransform: 'uppercase',
	},
	selectControl: {
		minHeight: '55px',
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.primary.main,
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.primary.main,
			borderWidth: 2,
		},
	},
}));

const OrderDetailTable = ({
	                          details,
	                          getStatus,
	                          handleOpenUpdateSlot,
	                          renderSlotTimeButtonOrText,
	                          handleShowUpdateSchedule,
	                          courierCompany,
	                          courierCompanyList,
	                          createUpdateCourierCompany,
	                          deliveryType,
	                          updateDeliveryType,
	                          orderPayment,
	                          colors,
	                          setCourierCompany,
	                          handleTrackingCode,
	                          trackingCode,
	                          setTrackingCode,
	                          setShowDeleteCode,
	                          trackingEvent,
	                          deliveryFee,
	                          onDeliveryFeeChange,
	                          calculatedTotals,
	                          orderCouponDiscount,
	                          onOrderCouponDiscountChange,
	                          onApplyCoupon,
	                          onAssignDriverClick,
	                        //   onDeliPointsClick
                          }) => {
	const classes = useStyles();
	const [showApplyCouponDialog, setShowApplyCouponDialog] = useState(false);
	const [couponCodeInput, setCouponCodeInput] = useState('');
	const [isLookingUpCoupon, setIsLookingUpCoupon] = useState(false);
	const [couponValidationState, setCouponValidationState] = useState(null); // 'valid', 'invalid', or null
	const [validationMessage, setValidationMessage] = useState('');

	// Initialize coupon code from details
	React.useEffect(() => {
		if (details?.coupon_codes && details.coupon_codes.length > 0 && details.coupon_codes[0]?.code) {
			setCouponCodeInput(details.coupon_codes[0].code);
			setCouponValidationState('valid'); // Assume existing coupon is valid
		}
	}, [details?.coupon_codes]);

	const handleApplyCoupon = (coupon) => {
		if (onApplyCoupon) {
			onApplyCoupon(coupon);
		}

		// Update the text field with the selected coupon code
		if (coupon && coupon.code) {
			setCouponCodeInput(coupon.code);
			setCouponValidationState('valid');

			// Build discount message
			let discountMsg = '';
			if (coupon.percentage > 0) {
				discountMsg = `${coupon.percentage}% OFF`;
			} else if (coupon.fixed > 0) {
				discountMsg = `$${coupon.fixed} OFF`;
			}
			setValidationMessage(discountMsg ? `Valid - ${discountMsg}` : 'Valid coupon');
		}
	};

	// Unified handler to remove coupon completely
	const handleRemoveCoupon = () => {
		// Clear text field
		setCouponCodeInput('');
		setCouponValidationState(null);
		setValidationMessage('');

		// Clear discount amount
		if (onOrderCouponDiscountChange) {
			onOrderCouponDiscountChange(0);
		}

		// Clear coupon ID
		if (onApplyCoupon) {
			onApplyCoupon(null);
		}
	};

	const handleCouponCodeLookup = async () => {
		const code = couponCodeInput.trim().toUpperCase();

		if (!code) {
			// Clear coupon if empty
			setCouponValidationState(null);
			setValidationMessage('');
			if (onApplyCoupon) {
				onApplyCoupon(null);
			}
			return;
		}

		setIsLookingUpCoupon(true);
		setCouponValidationState(null); // Clear previous state while validating

		try {
			const response = await API.lookupCouponByCode(code);
			const result = await response.json();

			if (result.success && result.data) {
				// Found valid coupon - apply it
				const coupon = {
					id: result.data.id,
					code: result.data.code,
					name: result.data.name,
					description: result.data.description,
					percentage: result.data.percentage,
					fixed: result.data.fixed
				};

				if (onApplyCoupon) {
					onApplyCoupon(coupon);
				}

				setCouponValidationState('valid');

				// Build discount message
				let discountMsg = '';
				if (result.data.percentage > 0) {
					discountMsg = `${result.data.percentage}% OFF`;
				} else if (result.data.fixed > 0) {
					discountMsg = `$${result.data.fixed} OFF`;
				}
				setValidationMessage(discountMsg ? `Valid - ${discountMsg}` : 'Valid coupon');
			} else {
				setCouponValidationState('invalid');
				setValidationMessage(result.message || 'Coupon code not found or inactive');

				// Reset to original code if lookup fails
				setTimeout(() => {
					if (details?.coupon_codes && details.coupon_codes.length > 0) {
						setCouponCodeInput(details.coupon_codes[0].code);
						setCouponValidationState('valid');
					} else {
						setCouponCodeInput('');
						setCouponValidationState(null);
					}
					setValidationMessage('');
				}, 3000); // Show error for 3 seconds
			}
		} catch (error) {
			console.error('Error looking up coupon:', error);
			setCouponValidationState('invalid');
			setValidationMessage('Failed to lookup coupon code');

			// Reset to original code
			setTimeout(() => {
				if (details?.coupon_codes && details.coupon_codes.length > 0) {
					setCouponCodeInput(details.coupon_codes[0].code);
					setCouponValidationState('valid');
				} else {
					setCouponCodeInput('');
					setCouponValidationState(null);
				}
				setValidationMessage('');
			}, 3000); // Show error for 3 seconds
		} finally {
			setIsLookingUpCoupon(false);
		}
	};

	return (
		<Row className={"w-auto"}>
			<Col>
				<Card className="h-100 w-auto overflow-auto">
					<CardHeader title={<Typography variant="h6"><b>ORDER INFO</b></Typography>} />
					<CardContent>
						<Table className={classes.table}>
							<TableBody>
								<TableRow>
									<TableCell className={classes.labelCell}>Order ID</TableCell>
									<TableCell className={classes.valueCell}>{details.order_id}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.labelCell}>Terminal Type</TableCell>
									<TableCell className={classes.valueCell}>
										<span className="text-capitalize">{details.platform || '-'}</span>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.labelCell}>Status</TableCell>
									<TableCell className={classes.valueCell}>
										<div style={{ display: 'flex', flexWrap:"wrap", alignItems: 'center' }}>
											<Chip
												size="small"
												className={classes.chip}
												style={{
													backgroundColor: details.status === 7 ? colors.secondary : colors.primary,
												}}
												label={getStatus(details.status)}
											/>
											<Tooltip title="View Histories">
												<HistoryIcon
													style={{ cursor: 'pointer' }}
													className="text-success ml-2"
													onClick={() => handleOpenUpdateSlot(true, details, 'order_status')}
												/>
											</Tooltip>
										</div>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.labelCell}>Placed At</TableCell>
									<TableCell className={classes.valueCell}>{details.placedAt}</TableCell>
								</TableRow>
								{details?.type !== 1 && (
									<TableRow>
										<TableCell className={classes.labelCell}>Delivery Time</TableCell>
										<TableCell className={classes.valueCell}>
											<div style={{ display: 'flex', alignItems: 'center' }}>
												{renderSlotTimeButtonOrText(details, handleShowUpdateSchedule)}
												<Tooltip title="View Histories">
													<HistoryIcon
														onClick={() => handleOpenUpdateSlot(true, details, 'timeslot_start_time')}
														style={{ cursor: 'pointer' }}
														className="text-success ml-2"
													/>
												</Tooltip>
											</div>
										</TableCell>
									</TableRow>
								)}
								<TableRow>
									<TableCell className={classes.labelCell}>Delivery Type</TableCell>
									<TableCell className={classes.valueCell}>
										<FormControl component="fieldset" fullWidth>
											<RadioGroup
												aria-label="delivery_type"
												name="delivery_type"
												value={deliveryType}
												onChange={(e) => updateDeliveryType(parseInt(e.target.value))}
											>
												<FormControlLabel value={1} control={<Radio color="primary" />} label="Delishop" />
												<FormControlLabel value={0} control={<Radio color="primary" />} label="Province" />
											</RadioGroup>

											{/* Conditionally render Courier Company section */}
											{details.status > 2 && details.external_courier === 0 && details.status !== 7 && deliveryType === 0 && (
												<Row className={""}>
													<Col xs={"12"}>
														<FormControl fullWidth variant="outlined" component="fieldset">
															<Select
																value={courierCompany}
																placeholder={"Select Courier Company"}
																className="basic-single"
																classNamePrefix="select"
																options={courierCompanyList}
																inputProps={{
																	autoComplete: 'off',
																	autoCorrect: 'off',
																	spellCheck: 'off'
																}}
																onChange={(e) => setCourierCompany(e)}
																style={{height: "100%"}}
																styles={{
																	control: (provided) => ({
																		...provided,
																		width: "100%",
																		minHeight: "40px", // Minimum height
																		borderColor: colors.primary, // Default border color
																		boxShadow: `3px solid ${colors.primary}`,
																		"&:hover": {
																			border: `2px solid ${colors.primary}`,
																			borderColor: colors.primary, // Default border color
																		}
																	}),
																	menu: (provided) => ({
																		...provided,
																		zIndex: 9999, // Ensure dropdown is above other elements
																	}),
																	option: (provided, state) => ({
																		...provided,
																		backgroundColor: state.isSelected ? colors.primary : null,
																		borderColor: colors.primary, // Default border color
																		boxShadow: `2px solid ${colors.primary}`,
																		color: state.isSelected ? colors.white : "#333",
																		"&:hover": {
																			backgroundColor: colors.primary,
																			borderColor: colors.primary, // Default border color
																			color: "#333",
																		},
																	})
																}}
															/>
														</FormControl>
													</Col>
													<Col xs="12" className="my-1">
														<TextField
															placeholder="Enter Tracking Code"
															variant="outlined"
															fullWidth
															size="small"
															value={trackingCode}
															onChange={(e) => setTrackingCode(e.target.value)}
															InputProps={{
																endAdornment: (trackingCode) && (
																	<InputAdornment position="end">
																		<Tooltip title="Delete shipment tracking">
																			<IconButton onClick={() => setShowDeleteCode(true)} edge="end">
																				<DeleteIcon className="text-danger"/>
																			</IconButton>
																		</Tooltip>
																	</InputAdornment>
																)
															}}
														/>
													</Col>
													<Col xs={"12"}>
														<MButton
															variant="contained"
															style={{background: colors.primary, color: colors.white}}
															size="small"
															className={"float-right"}
															onClick={() => handleTrackingCode("create")}
														>
															check tracking status
														</MButton>
													</Col>
												</Row>
											)}
										</FormControl>
									</TableCell>
								</TableRow>

								{/* Assigned Drivers */}
								<TableRow>
									<TableCell className={classes.labelCell}>Assigned Drivers</TableCell>
									<TableCell className={classes.valueCell}>
										<div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
											<div>
												{details.driver ? (
													<div>
														<Typography variant="body2" component="span"
														            style={{fontWeight: 600}}>Primary: </Typography>
														{details.driver.first_name} {details.driver.last_name}
													</div>
												) : <Typography variant="caption" color="textSecondary">No Primary Driver</Typography>}

												{(details.secondaryDriver || (details.secondary_driver_id && details.secondary_driver_id !== 0)) && (
													<div style={{marginTop: 4}}>
														<Typography variant="body2" component="span"
														            style={{fontWeight: 600}}>Secondary: </Typography>
														{details.secondaryDriver ?
															`${details.secondaryDriver.first_name} ${details.secondaryDriver.last_name}` :
															"Assigned"}
													</div>
												)}
											</div>
											<Button
												size="small"
												variant="outlined"
												color="primary"
												onClick={onAssignDriverClick}
												style={{marginLeft: 8}}
											>
												Assign/Edit
											</Button>
										</div>
									</TableCell>
								</TableRow>

								<TableRow>
									<TableCell className={classes.labelCell}>Subtotal</TableCell>
									<TableCell className={classes.valueCell}>
										{calculatedTotals?.item_total !== undefined
											? `$${calculatedTotals.item_total.toFixed(2)}`
											: details.item_total}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.labelCell}>Delivery Fees</TableCell>
									<TableCell className={classes.valueCell}>
										<TextField
											type="number"
											size="small"
											value={deliveryFee || 0}
											onChange={(e) => onDeliveryFeeChange(parseFloat(e.target.value) || 0)}
											inputProps={{min: 0, step: 0.01, style: {textAlign: 'left'}}}
											style={{width: 100}}
											InputProps={{
												startAdornment: <Typography style={{marginRight: 4}}>$</Typography>,
											}}
										/>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.labelCell}>Coupon Discount Amount</TableCell>
									<TableCell className={classes.valueCell}>
										<div style={{display: 'flex', alignItems: 'center', gap: 8}}>
									<span style={{fontWeight: 'bold', color: '#000'}}>
										{(() => {
											let discountAmount = 0;
											// Priority: calculatedTotals (from recalculate) > orderCouponDiscount (from state) > details (saved)
											// If calculatedTotals exists and has a value > 0, use it
											if (calculatedTotals?.coupon_discount_amount !== undefined && calculatedTotals.coupon_discount_amount > 0) {
												discountAmount = calculatedTotals.coupon_discount_amount;
											} else if (orderCouponDiscount > 0) {
												// Use orderCouponDiscount from state (includes initial load from details)
												discountAmount = orderCouponDiscount;
											} else if (calculatedTotals?.coupon_discount_amount === 0) {
												// Explicitly set to 0 after recalculate (coupon removed)
												discountAmount = 0;
											} else {
												// Fallback to saved order-level discount (for backwards compatibility)
												discountAmount = details.order_payment_summery?.coupon_discount_amount
													|| details.coupon_discount_amount
													|| details.coupon_discount
													|| 0;
											}
											return `$${parseFloat(discountAmount).toFixed(2)}`;
										})()}
											</span>
											{((calculatedTotals?.coupon_discount_amount !== undefined && calculatedTotals.coupon_discount_amount > 0) ||
												(orderCouponDiscount > 0 || (orderCouponDiscount === null && ((details.order_payment_summery?.coupon_discount_amount > 0) || (details.coupon_discount_amount > 0) || (details.coupon_discount > 0))))) ? (
												<Button
													size="small"
													variant="contained"
													onClick={handleRemoveCoupon}
													style={{
														backgroundColor: '#f44336',
														color: 'white',
														textTransform: 'none',
														fontSize: '0.75rem',
														padding: '2px 8px',
														minWidth: 'auto'
													}}
												>
													Remove Coupon
												</Button>
											) : (
												<Button
													size="small"
													variant="contained"
													onClick={() => setShowApplyCouponDialog(true)}
													startIcon={<AddIcon fontSize="small"/>}
													style={{
														backgroundColor: '#4caf50',
														color: 'white',
														textTransform: 'none',
														fontSize: '0.75rem',
														padding: '2px 8px',
														minWidth: 'auto'
													}}
												>
													Apply Coupon
												</Button>
											)}
										</div>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.labelCell}>Coupon Code</TableCell>
									<TableCell className={classes.valueCell}>
										<div style={{display: 'flex', flexDirection: 'column', gap: 4}}>
											<div style={{display: 'flex', alignItems: 'center', gap: 8}}>
												<TextField
													size="small"
													placeholder="Enter coupon code..."
													value={couponCodeInput}
													onChange={(e) => {
														setCouponCodeInput(e.target.value.toUpperCase());
														setCouponValidationState(null); // Clear validation when typing
														setValidationMessage('');
													}}
													onBlur={handleCouponCodeLookup}
													onKeyPress={(e) => {
														if (e.key === 'Enter') {
															handleCouponCodeLookup();
														}
													}}
													disabled={isLookingUpCoupon}
													style={{width: 200}}
													InputProps={{
														endAdornment: isLookingUpCoupon ? (
															<CircularProgress size={20} style={{marginRight: 8}}/>
														) : couponValidationState === 'valid' ? (
															<CheckCircleIcon style={{color: '#4caf50', marginRight: 8}} fontSize="small"/>
														) : couponValidationState === 'invalid' ? (
															<ErrorIcon style={{color: '#f44336', marginRight: 8}} fontSize="small"/>
														) : null,
													}}
												/>
												{couponCodeInput && !isLookingUpCoupon && (
													<Tooltip title="Clear coupon code">
														<IconButton
															size="small"
															onClick={handleRemoveCoupon}
														>
															<DeleteIcon fontSize="small"/>
														</IconButton>
													</Tooltip>
												)}
											</div>
											{validationMessage && (
												<Typography
													variant="caption"
													style={{
														color: couponValidationState === 'valid' ? '#4caf50' : '#f44336',
														fontSize: '0.75rem',
														marginLeft: 4
													}}
												>
													{validationMessage}
												</Typography>
											)}
										</div>
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.labelCell}>DeliPoints Earned</TableCell>
									<TableCell className={classes.valueCell}>{details.dp_points_earned ?? '-'}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.labelCell}>DeliPoints Redeemed</TableCell>
									<TableCell className={classes.valueCell}>{details.dp_points_redeemed ?? '-'}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.labelCell}>DeliPoints Payment</TableCell>
									<TableCell className={classes.valueCell}>{details.dp_discount_payment != null ? `$${parseFloat(details.dp_discount_payment).toFixed(2)}` : '-'}</TableCell>
								</TableRow>
								{/* {onDeliPointsClick && (
									<TableRow>
										<TableCell colSpan={2} style={{ paddingTop: 4, paddingBottom: 4 }}>
											<Button
												variant="text"
												size="small"
												startIcon={<CardGiftcardIcon style={{ color: colors.primary }} />}
												onClick={onDeliPointsClick}
												style={{ textTransform: 'none', color: colors.primary }}
											>
												Edit DeliPoints
											</Button>
										</TableCell>
									</TableRow>
								)} */}
							</TableBody>
						</Table>
					</CardContent>
				</Card>
			</Col>

			{/* Apply Coupon Dialog */}
			<ApplyCouponDialog
				open={showApplyCouponDialog}
				onClose={() => setShowApplyCouponDialog(false)}
				orderId={details.order_id}
				userId={details.user_id || details.cust_id}
				onApply={handleApplyCoupon}
			/>
		</Row>
	);
};

export default OrderDetailTable;